import React from 'react';
import styled from 'styled-components';
import CourseCard from '../common/CourseCard';
import { colors } from '../../styles/variables';
import { coursesData } from '../../data/coursesData';

const CoursesSection = styled.section`
  padding: 80px 24px;
`;

const CoursesContainer = styled.div`
  max-width: 1240px;
  margin: 0 auto;
`;

const SectionHeader = styled.div`
  text-align: center;
  margin-bottom: 64px;
`;

const SectionTitle = styled.h2`
  font-size: 36px;
  font-weight: 700;
  color: ${colors.primary};
  margin-bottom: 16px;
`;

const SectionSubtitle = styled.p`
  font-size: 18px;
  color: ${colors.textGray};
  max-width: 600px;
  margin: 0 auto;
`;

const CourseGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 32px;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
    gap: 24px;
  }
`;

const Courses = () => {
  return (
    <CoursesSection id="courses">
      <CoursesContainer>
        <SectionHeader>
          <SectionTitle>스터디 과정 소개</SectionTitle>
          <SectionSubtitle>
            현업 개발자의 실무 경험을 바탕으로 설계된 체계적인 커리큘럼으로 
            실전에 바로 적용 가능한 역량을 키워보세요.
          </SectionSubtitle>
        </SectionHeader>
        
        <CourseGrid>
          {coursesData.map((course, index) => (
            <CourseCard
              key={index}
              tag={course.tag}
              title={course.title}
              description={course.description}
              features={course.features}
              imageClass={course.imageClass}
              bgColor={course.bgColor}
              bgImage={course.bgImage}
              link={course.link}
            />
          ))}
        </CourseGrid>
      </CoursesContainer>
    </CoursesSection>
  );
};

export default Courses;
